import React, { useRef, useState, useEffect } from 'react';
import './CreateBugModal.css';

const CreateBugModal = ({ isOpen, onClose, onCreate, storyKey, caseId, cycleId, issueType = 'bug' }) => {
  const evidenceInputRef = useRef(null);
  const [summary, setSummary] = useState('');
  const [description, setDescription] = useState('');
  const [parentKey, setParentKey] = useState(storyKey || '');
  const [relation, setRelation] = useState('Relates');
  const [evidenceFile, setEvidenceFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const normalizedType = String(issueType || 'bug').toLowerCase() === 'improvement' ? 'improvement' : 'bug';
  const modalTitle = normalizedType === 'improvement' ? 'Criar Melhoria' : 'Criar Bug';
  const summaryPlaceholder = normalizedType === 'improvement' ? 'Resumo da melhoria' : 'Resumo do bug';
  const descriptionPlaceholder = normalizedType === 'improvement'
    ? 'Detalhes da melhoria sugerida, contexto e beneficio esperado.'
    : 'Detalhes do bug, passos para reproduzir, etc.';
  const submitLabel = normalizedType === 'improvement' ? 'Criar Melhoria' : 'Criar Bug';
  const loadingLabel = normalizedType === 'improvement' ? 'Criando melhoria...' : 'Criando...';

  useEffect(() => {
    if (isOpen) {
      setSummary('');
      setDescription('');
      setParentKey(storyKey || '');
      setRelation('Relates');
      setEvidenceFile(null);
      if (evidenceInputRef.current) evidenceInputRef.current.value = '';
    }
  }, [isOpen, storyKey]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await onCreate({
      summary,
      description,
      storyKey: parentKey,
      relation,
      evidenceFile,
      caseId,
      cycleId,
      issueType: normalizedType
    });
    setLoading(false);
  };

  const handleEvidenceChange = (e) => {
    const file = e.target.files && e.target.files[0] ? e.target.files[0] : null;
    setEvidenceFile(file);
  };

  const clearEvidence = () => {
    setEvidenceFile(null);
    if (evidenceInputRef.current) evidenceInputRef.current.value = '';
  };

  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content bug-modal" onClick={handleContentClick}>
        <div className="modal-header">
          <h2>{modalTitle}</h2>
          <button className="close-button" onClick={onClose}>x</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Titulo *</label>
            <input
              type="text"
              value={summary}
              onChange={e => setSummary(e.target.value)}
              required
              placeholder={summaryPlaceholder}
            />
          </div>

          <div className="form-group">
            <label>Descricao *</label>
            <textarea
              rows="6"
              value={description}
              onChange={e => setDescription(e.target.value)}
              required
              placeholder={descriptionPlaceholder}
            />
          </div>

          <div className="form-group">
            <label>Story Pai (opcional)</label>
            <input
              type="text"
              value={parentKey}
              onChange={e => setParentKey(e.target.value)}
              placeholder="Ex: SCRUM-10"
            />
            <small>Chave da historia no Jira (preenchido automaticamente se disponivel)</small>
          </div>

          <div className="form-group">
            <label>Tipo de vinculo</label>
            <select value={relation} onChange={e => setRelation(e.target.value)}>
              <option value="Relates">Relates to</option>
              <option value="Blocks">Blocks</option>
              <option value="is caused by">Is caused by</option>
              <option value="causes">Causes</option>
              <option value="is blocked by">Is blocked by</option>
            </select>
          </div>

          <div className="form-group">
            <label>Evidencia (opcional)</label>
            <input
              type="file"
              accept="image/*,video/*"
              onChange={handleEvidenceChange}
              disabled={loading}
              ref={evidenceInputRef}
            />
            {evidenceFile && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 6 }}>
                <small style={{ margin: 0 }}>{evidenceFile.name}</small>
                <button
                  type="button"
                  className="btn-cancel"
                  onClick={clearEvidence}
                  disabled={loading}
                  style={{ padding: '0.2rem 0.6rem' }}
                >
                  Remover
                </button>
              </div>
            )}
          </div>

          <div className="modal-actions">
            <button type="button" className="btn-cancel" onClick={onClose} disabled={loading}>
              Cancelar
            </button>
            <button type="submit" className="btn-save" disabled={loading}>
              {loading ? loadingLabel : submitLabel}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateBugModal;
